export default __webpack_public_path__ + "media/images/add-group-ac45d975916b6cec7711331358211e48.png";